
  import * as storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc from '/app/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as defaultRuntime$PYvhu9xrTUUzZER2Z5RtANxHD2h9baj9hB1n9mGLmbI from '/app/apps/mad/providers/default/index.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1440,
    "3xl": 1680,
    "4xl": 1920
  },
  "presets": {},
  "provider": "default",
  "domains": [
    "a.storyblok.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc, defaults: {"baseURL":"https://a.storyblok.com","modifiers":{"quality":"85"}} },
  ['default']: { provider: defaultRuntime$PYvhu9xrTUUzZER2Z5RtANxHD2h9baj9hB1n9mGLmbI, defaults: {"baseURL":""} }
    }
  }
